// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-372ac756]{width:900px;height:440px;position:absolute;left:27%;top:28%;z-index:8}", ""]);
// Exports
module.exports = exports;
